export function formatProductId(productType: "Course" | "Accommodation" | "AddOn" | "Transfer", id: number | string): string {
    return `${productType}-${id}`;
}

export function parseProductId(value: string): number {
    if (value == null || typeof value !== "string") return NaN;
    const match = /^(Course|Accommodation|AddOn|Transfer)-(\d+)$/i.exec(value.trim());
    if (!match) return NaN;
    const n = parseInt(match[2], 10);
    return Number.isFinite(n) ? n : NaN;
}